<template>
	<div
		:class="{ active: active, disabled: disabled, completed: completed }"
		class="step"
	>
		<!-- <i class="truck icon"></i> -->
		<div class="content">
			<p class="title">
				{{ title }}
			</p>
			<p class="description">
				{{ description }}
			</p>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		completed: {
			type: Boolean,
			default: false,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		active: {
			type: Boolean,
			default: true,
		},
		title: {
			type: String,
		},
		description: {
			type: String,
		},
	},
}
</script>

<style scoped>
.title,
.description {
	margin: 0 !important;
	line-height: normal;
}

/* ----------- Non-Retina Screens ----------- */
@media screen and (min-device-width: 1200px) and (max-device-width: 1600px) {
	.title {
		font-size: 1rem !important;
		margin: 0;
	}

	.description {
		font-size: 0.6rem !important;
	}

	.step:before {
		font-size: 1rem !important;
	}
}
</style>
